module.exports = __webpack_public_path__ + "static/media/Eyescream.9852a45f.png";